window.$bind = function $bind(o, m) {
  var f = function() {
    return f.method.apply(f.scope, arguments)
  };
  f.scope = o;
  f.method = m;
  return f
}

/**
 * Replaces member functions of o with wrapper functions that ensure
 * that o is passed as "this" to the member function.
 *
 * @param {Object} o
 * @param {Array<String>} ms - The names of the functions to bind. (If omitted, all functions are bound.)
 */
window.$bindAll = function $bindAll(o, ms) {
    function isUnboundFunction(f) {
        return (typeof f === "function" && !("scope" in f));
    }
    if (ms) {
        ms.forEach(function(m) {
            if (isUnboundFunction(o[m])) {
                o[m] = $bind(o, o[m]);
            }
        });
    }
    else {
        for (m in o) {
            if (isUnboundFunction(o[m])) {
                o[m] = $bind(o, o[m]);
            }
        }
    }
}

/* generate inits */
Object.defineProperty(String.prototype, "__class__", {
	value: $hxClasses.String = String,
	enumerable:false
});
String.__name__ = ["String"];
Object.defineProperty(Array.prototype, "__class__", {
	value: $hxClasses.Array = Array,
	enumerable:false
});
Array.__name__ = ["Array"];
Object.defineProperty(Date.prototype, "__class__", {
	value: $hxClasses.Date = Date,
	enumerable:false
});

Date.__name__ = ["Date"];
window.Int = $hxClasses.Int = { __name__ : ["Int"]};
window.Dynamic = $hxClasses.Dynamic = { __name__ : ["Dynamic"]};
window.Float = $hxClasses.Float = Number;
Float.__name__ = ["Float"];
window.Bool = $hxClasses.Bool = Boolean;
Bool.__ename__ = ["Bool"];
window.Class = $hxClasses.Class = { __name__ : ["Class"]};
window.Enum = { };
window.Void = $hxClasses.Void = { __ename__ : ["Void"]};

if (Array.prototype.indexOf) {
	HxOverrides.remove = function (a, o) {
		var i = a.indexOf(o);
		if (i == -1) return false;
		a.splice(i, 1);
		return true;
	}
}

Math.__name__ = ["Math"];
Math.NaN = Number.NaN;
Math.NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY;
Math.POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
$hxClasses.Math = Math;
Math.isFinite = function(i) {
	return isFinite(i);
};
Math.isNaN = function(i) {
	return isNaN(i);
};


if(typeof document != "undefined") js.Lib.document = document;
if(typeof window != "undefined") {
	js.Lib.window = window;
}
/* *
ie8  does not recognize members defined on iframe in included javascript files unless explicitly declared
 */
if(com.inq.flash.client.control.FlashPeer.getIsSkinLocal() && (com.inq.utils.Capabilities.getIeVersion()==8)){
	window.Application=Application;
}


if (com.inq.flash.client.control.FlashPeer.getIsBuilder()) {
	Application.main();
}

/**
 * Application.main should be available in IJSF by this name after obfuscation.
 *
 */
com.inq.utils.Util.publish("Application.main", Application.main);

/**
 * Implements mapping of obfuscated IJSF functions to CI
 * Application.fpInit is public alias for CI FlashPeer.init, used to avoid any issues with obfuscation of CI in future.
 */
com.inq.utils.Util.publish("Application.fpInit", com.inq.flash.client.control.FlashPeer.init);